export enum WhatsappAccountOriginEnum {
  WHITELISTED = 'whitelisted',
  VONAGE = 'vonage',
  CLOUDAPI = 'cloudapi',
}
